import { Component } from 'react';
import {connect} from 'react-redux';
import {actions} from 'forms/rrf';
import {Link} from 'react-router-dom';
import {Col, Container, Row} from 'react-bootstrap';
import ArticlesList from './articles-list';
import ArticlesSearch from './articles-search';
import {getArticles} from '../../../../../actions/news';
import ArrowButton from '../../../../common/button-arrow';
import PageTitle from '../../../../common/page-title/index';

import './styles.css';

class Articles extends Component {
  state = {
    title: '',
    dateFrom: '',
    dateTo: '',
    status: 'Published',
    orderBy: 'display_from_date',
    order: 'desc',
    pageNumber: 1
  };
  handleInputChange = (e) => {
    this.setState({title: e.target.value});
  };
  handleDateFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({dateFrom: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateFrom: ''});
    }
  };
  handleDateToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({dateTo: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateTo: ''});
    }
  };
  handleStatusChange = (e) => {
    this.setState({status: e.target.value});
  };
  handleOrderByChange = (e) => {
    this.setState({orderBy: e.target.value});
  };
  handleOrderChange = (e) => {
    this.setState({order: e.target.value});
  };
  handleSearch = () => {
    const {
      title, dateFrom, dateTo, status, orderBy, order, pageNumber
    } = this.state;
    this.props.dispatch(getArticles(title, dateFrom, dateTo, status, orderBy, order, pageNumber));
  };
  handleClear = () => {
    this.setState({
      title: '',
      dateFrom: '',
      dateTo: '',
      status: '',
      orderBy: '',
      order: 'desc',
      pageNumber: 1
    }, this.handleSearch);
  };

  handlePageChange = (page) => {
    this.setState({pageNumber: page}, this.handleSearch);
  };

  UNSAFE_componentWillMount() {
    this.props.dispatch(actions.load('deep.admin_news.article', {
      news_category_id: 0,
      status: '',
      linked_article_ids: [],
      permission_ids: {}
    }));
    this.handleSearch();
  }

  render() {
    return (
      <Container fluid className="news">
        <PageTitle>
          Articles
        </PageTitle>
        <Link to="/admin/news/articles/new">
          <ArrowButton
            arrow={false}
            className="add-article"
            color="red"
            permissions={{
              action: 'create',
              subjectClass: 'Article'
            }}
            submit={false}
          >
            Add article
          </ArrowButton>
        </Link>

        <Row>
          <Col md={12}>
            <ArticlesSearch
              dateFromValue={this.state.dateFrom}
              dateToValue={this.state.dateTo}
              onClear={this.handleClear}
              onDateFromChange={this.handleDateFromChange}
              onDateToChange={this.handleDateToChange}
              onInputChange={this.handleInputChange}
              onOrderByChange={this.handleOrderByChange}
              onOrderChange={this.handleOrderChange}
              onSearch={this.handleSearch}
              onStatusOrderChange={this.handleStatusChange}
              searchValue={this.state.title}
              orderByValue={this.state.orderBy}
              orderValue={this.state.order}
              statusList={this.props.statusList}
              statusOrderValue={this.state.status}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ArticlesList
              articles={this.props.articles}
              fetched={this.props.fetched}
              fetching={this.props.fetching}
              currentPage={this.state.pageNumber}
              onPageChange={this.handlePageChange}
              paging={this.props.paging}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  articles: state.news.articles.articles,
  statusList: state.news.articles.statusList,
  fetching: state.news.articles.fetching,
  fetched: state.news.articles.fetched,
  paging: state.news.articles.paging
});

export default connect(mapStateToProps)(Articles);
